import React from "react";
import {
  ChakraProvider,
  Box,
  VStack,
  Heading,
  Tooltip,
} from "@chakra-ui/react";
import ToolTipRotate from "./components/tooltiprotate";
import CreateTableFromFile from "./components/CreateTableFromFile";
import FileUploadSection from "./components/FileUploadSection";

function App() {
  return (
    <ChakraProvider>
      <Box minH="100vh" bg="gray.100" py={10}>
        <VStack spacing={8}>
          <Heading style={{ marginBottom: "15px", color: "Blueblack" }}>
            Welcome To AISC World
          </Heading>
          <ToolTipRotate />
        </VStack>
      </Box>
    </ChakraProvider>
  );
}

export default App;
